import TimeUtils from './TimeUtils';

export default class FrameUtils {
  /**
   * 取得是否有 FrameSplit 錯誤
   * @param {*} dataObj 當前的 Out  
   * @param {*} dataObj_next 下一個 In 
   * @param {*} _frameCheckValue 檢查標準
   */
  static isDataObjGetFrameSplit(dataObj, dataObj_next, _frameCheckValue ) {
    
    let Out = dataObj.Out;

    let In_next = dataObj_next.In;

    if (In_next !== '' && Out !== '') {
      const Out_frame = parseFloat(
        parseFloat(TimeUtils.timeString_convertTo_frame(Out)).toFixed(2)
      );
      const In_next_frame = parseFloat(
        parseFloat(TimeUtils.timeString_convertTo_frame(In_next)).toFixed(2)
      );

      // 兩者的距離
      const frameDistance = parseFloat(
        parseFloat(In_next_frame - Out_frame).toFixed(2)
      );

      //如果尾巴更多於下一個的起始
      if (
        parseFloat(frameDistance) < parseFloat(_frameCheckValue) ||
        parseFloat(Out_frame) >= parseFloat(In_next_frame)
      ) {
        // 有錯誤
        return true;
      }else{
        return false; 
      }
    }else{
      return false; 
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/FrameUtils.js